import axios from 'axios';
import { useState, useEffect } from 'react';
import { GraphData } from '../..';

const useGraphData = (players: string[], fullCareer: boolean) => {
  const [graphData, setGraphData] = useState<GraphData[]>([]);
  useEffect(() => {
    (async () => {
      const { data }: { data: GraphData[] } = await axios.post(`${process.env.REACT_APP_API_URL}/graphData`,
        { players, full_career: fullCareer });
      setGraphData(data);
    })()
  }, [players, fullCareer])
  return graphData
}

export default useGraphData;